/* eslint-disable import/no-mutable-exports */
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import _ from 'lodash';
import { composeWithDevTools } from 'redux-devtools-extension'; // eslint-disable-line import/no-extraneous-dependencies
import logger from 'redux-logger';
import rootReducer from './reducers';
import gatekeeperMiddleware from './gatekeeperMiddleware';
import sagas from './sagas';

const middleware = createSagaMiddleware();
const NODE_ENV = process.env.NODE_ENV || 'production';
// mount it on the Store

let store;
/*if (NODE_ENV !== 'production') {
  store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(gatekeeperMiddleware, logger, middleware)),
  );
} else {*/
  store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(gatekeeperMiddleware, middleware)),
  );
//}

// then run the sagas
sagas.forEach((saga, index) => {
  try {
    middleware.run(saga);
  } catch (err) {
    // THIS IS IMPORTANT DATA - please keep
    console.log('---------- cannot run saga ', _.get(saga, 'name', saga), err, 'index:', index);
  }
});

export default store;
